import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "template", 
    "content", 
    "contractTypeFields",
    "contractableType",
    "contractableId",
    "partyAType",
    "partyAId",
    "partyBType",
    "partyBId",
    "partyAIdContainer",
    "partyBIdContainer"
  ]

  connect() {
    if (this.hasTemplateTarget) {
      this.templateTarget.addEventListener("change", this.handleTemplateChange.bind(this))
    }
  }

  disconnect() {
    if (this.hasTemplateTarget) {
      this.templateTarget.removeEventListener("change", this.handleTemplateChange.bind(this))
    }
  }

  templateChanged(event) {
    this.handleTemplateChange(event)
  }

  handleTemplateChange(event) {
    const templateId = event.target.value

    if (!templateId) {
      this.hideAllContractFields()
      return
    }

    // Fetch the template content and type
    fetch(`/admin/contract_templates/${templateId}/preview.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        return response.json()
      })
      .then(data => {
        if (this.hasContentTarget && data.content) {
          this.contentTarget.value = data.content
        }
        
        // Show/hide appropriate fields based on template type
        this.showContractFieldsForType(data.template_type)
      })
      .catch(error => {
        console.error("Error fetching template content:", error)
      })
  }
  
  showContractFieldsForType(templateType) {
    // Hide all contract type specific fields
    this.hideAllContractFields()
    
    // Show the appropriate fields
    const fieldsToShow = document.querySelector(`[data-contract-type="${templateType}"]`)
    if (fieldsToShow) {
      fieldsToShow.style.display = "block"
    } else if (templateType !== "facilitator_contract") {
      // Show generic fields for other contract types
      const genericFields = document.querySelector('[data-contract-type="generic"]')
      if (genericFields) {
        genericFields.style.display = "block"
      }
    }
  }
  
  hideAllContractFields() {
    const allFields = document.querySelectorAll('[data-contract-type]')
    allFields.forEach(field => {
      field.style.display = "none"
    })
  }
  
  partyTypeChanged(event) {
    const target = event.target
    const partyType = target.value
    const isPartyA = target.dataset.contractTemplateTarget === "partyAType"
    
    if (!partyType) {
      return
    }
    
    // Update the options for the corresponding party select
    const selectTarget = isPartyA ? this.partyAIdTarget : this.partyBIdTarget
    const options = this.getOptionsForPartyType(partyType)
    
    // Clear current options
    selectTarget.innerHTML = '<option value="">Select Party</option>'
    
    // Add new options
    options.forEach(option => {
      const optionElement = document.createElement('option')
      optionElement.value = option.id
      optionElement.textContent = option.name
      selectTarget.appendChild(optionElement)
    })
  }
  
  getOptionsForPartyType(type) {
    if (!window.contractPartyOptions) {
      return []
    }
    
    switch(type) {
      case 'Account':
        return window.contractPartyOptions.accounts || []
      case 'User':
        return window.contractPartyOptions.users || []
      default:
        return []
    }
  }
}